// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------
SHARED VARIABLES
--------------------*/
/*--------------------
GENERAL
--------------------*/
*,
*:before,
*:after {
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
}

body {
  background: #f2f2f2;
  font-family: "Roboto", verdana, sans-serif;
  height: 100%;
}

h1 {
  font-size: 1.5em;
  font-weight: 100;
}

#cardForm {
  height: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
}

/*--------------------
PANEL FORM
--------------------*/
.panel {
  background: #fff;
  width: 80%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  box-shadow: none;
}

.panel__header {
  background: #3f51b5;
  color: #fff;
}

.panel__header,
.panel__footer {
  padding: 1em 2em;
}

.panel__footer {
  background: #f3f3f3;
}

.panel__content {
  padding: 1em 2em;
  overflow: hidden;
}

.textfield--float-label {
  width: 50%;
  float: left;
  display: inline-block;
  padding-right: 5px;
}

.hosted-field--label {
  transform: translateY(0.4em);
  font-size: 1.125em;
  line-height: 32px;
  transition: all 0.15s ease-out;
  display: block;
  width: 100%;
  font-weight: 400;
  overflow: hidden;
  margin-bottom: 0.5em;
}
.hosted-field--label.label-float, .hosted-field--label.invalid, .hosted-field--label.filled {
  text-overflow: ellipsis;
  color: #2196f3;
  transition: all 0.15s ease-out;
}
.hosted-field--label.filled {
  color: rgba(0, 0, 0, 0.54);
}
.hosted-field--label.invalid {
  color: #f44336;
}

span.icon {
  position: relative;
  top: 0.2em;
  margin-right: 0.2em;
}

svg {
  fill: #333;
}

.hosted-field {
  height: 32px;
  margin-bottom: 1em;
  display: block;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.87);
  border: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);
  outline: 0;
  width: 100%;
  font-size: 16px;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  position: relative;
}

.pay-button {
  background: #e91e63;
  color: #fff;
  margin: 0 auto;
  border: 0;
  border-radius: 3px;
  padding: 1em 3em;
  font-size: 1em;
  text-transform: uppercase;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.2);
}

/*--------------------
BT HOSTED FIELDS SPECIFIC 
--------------------*/
.braintree-hosted-fields-focused {
  border-bottom: 2px solid #3f51b5;
  transition: all 200ms ease;
}

.braintree-hosted-fields-invalid {
  border-bottom: 2px solid #e91e63;
  transition: all 200ms ease;
}

/*---------------------
Media Queries
----------------------*/
@media (max-width: 600px) {
  html {
    overflow: auto;
  }
  #cardForm {
    height: auto;
    margin: 2em;
    font-size: 13px;
  }
  .panel {
    width: 100%;
  }
  .textfield--float-label {
    width: 100%;
    float: none;
    display: inline-block;
  }
  .pay-button {
    width: 100%;
  }
}
/*design starts here*/
.checkout-wrap {
  display: flex;
  align-items: flex-start;
  padding: 2rem 3rem;
  margin: 0px auto;
  width: 100%;
}
.checkout-wrap .left-panel {
  width: 70%;
}
.checkout-wrap .left-panel .panel {
  width: 100%;
}
.checkout-wrap .left-panel .panel span.icon {
  top: 0px;
}
.checkout-wrap .left-panel .header-wrap {
  display: flex;
}
.checkout-wrap .left-panel .header-wrap h1 {
  flex: 1;
}
.checkout-wrap .left-panel .header-wrap .se-check {
  display: flex;
}
.checkout-wrap .left-panel .header-wrap .se-check span {
  order: 2;
  margin-left: 10px;
  color: rgba(0, 0, 0, 0.54) !important;
}
.checkout-wrap .right-panel {
  width: 27%;
  background: #fff;
  height: 100vh;
  position: fixed;
  right: 2rem;
  top: 80px;
}
.checkout-wrap .right-panel .subscription-box {
  margin: 30px;
  padding: 20px 0px 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
}
.checkout-wrap .right-panel .subscription-box h3 {
  display: flex;
  align-items: center;
}
.checkout-wrap .right-panel .subscription-box h3.back-link {
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}
.checkout-wrap .right-panel .subscription-box h3 mat-icon {
  margin-right: 4px;
  font-size: 22px;
  width: 22px;
  height: 22px;
  line-height: 22px;
}
.checkout-wrap .right-panel .subscription-box .sub-boxheading {
  padding: 20px;
  border-bottom: 1px solid #ddd;
}
.checkout-wrap .right-panel .subscription-box .sub-boxdetails {
  padding: 20px;
}
.checkout-wrap .right-panel .subscription-box .sub-boxdetails h4 {
  margin: 0px 0px 20px;
}
.checkout-wrap .right-panel .subscription-box .sub-boxdetails p span {
  margin-left: 10px;
}
.checkout-wrap .right-panel .subscription-box .sub-boxdetails p i {
  margin-right: 10px;
}
.checkout-wrap .right-panel .subscription-box .sub-boxdetails p.Total {
  color: red !important;
  font-size: 18px !important;
  font-weight: bold !important;
}
.checkout-wrap .right-panel .in-group {
  display: flex;
}
.checkout-wrap .right-panel .in-group input {
  font-size: 18px;
  height: 64px;
  padding: 20px 22px 0;
  background-color: #fff;
  -webkit-appearance: none;
          appearance: none;
  border-radius: 9px;
  border: 1px solid #c4c5ca;
  box-sizing: border-box;
  caret-color: #282d3d;
  color: #282d3d;
  display: inline-block;
  filter: none;
  font-weight: 400;
  height: 60px;
  letter-spacing: normal;
  line-height: normal;
  outline: none;
  padding: 0 30px;
  resize: none;
  vertical-align: middle;
  width: 100%;
}
.checkout-wrap .right-panel .in-group button {
  width: 100px;
  height: 80px;
  border-radius: 9px;
  height: 60px;
  justify-content: center;
  min-width: 88px;
  width: 35%;
  border: 0px;
  background: rgb(94, 161, 216);
  color: #fff;
  margin-left: -10px;
}
.checkout-wrap header {
  background: transparent;
}
.checkout-wrap header h1 {
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: bold;
  font-size: 26px !important;
}

.panel__footer button {
  display: block;
  margin: 0px auto;
  background: #5ea1d8;
  color: #fff;
}

.textfield--float-label {
  position: relative;
}

.card-list {
  display: flex;
  position: absolute;
  right: 0px;
  z-index: 10;
}
.card-list ul {
  list-style: none;
  display: flex;
  margin: 0px;
  height: 32px;
  align-items: end;
}
.card-list ul li {
  width: 20px;
  margin: 0px 3px;
  cursor: pointer;
}

@media (max-width: 992px) {
  #cardForm {
    margin: 0px;
  }
  .checkout-wrap {
    padding: 15px;
    flex-direction: column;
  }
  .checkout-wrap .left-panel {
    width: 100%;
  }
  .checkout-wrap .left-panel .header-wrap .se-check {
    align-items: center;
  }
  .checkout-wrap .right-panel {
    position: relative;
    width: 100%;
    right: 0px;
    top: 0px;
    height: auto;
    order: 1;
  }
  .checkout-wrap .right-panel .subscription-box {
    padding: 15px;
    margin: 75px 0px 30px !important;
  }
  .checkout-wrap .right-panel .subscription-box .sub-boxheading {
    padding: 5px 0px;
  }
  .checkout-wrap .right-panel .subscription-box .sub-boxheading h2 {
    font-size: 24px !important;
  }
  .checkout-wrap .right-panel .subscription-box .sub-boxheading h4 {
    font-size: 20px !important;
  }
  .checkout-wrap .right-panel .subscription-box .sub-boxheading h3 {
    margin-bottom: 5px !important;
  }
  .checkout-wrap .right-panel .subscription-box .sub-boxdetails {
    padding: 0px;
  }
  .checkout-wrap .left-panel {
    order: 2;
  }
}
#paypal-container {
  margin-left: 30px;
}
#paypal-container button {
  background: #ffc43a;
  border-radius: 5px;
  border: 0px;
  padding: 5px 80px;
  font-weight: 900;
  color: #009cdf;
  font-style: italic;
  font-size: 23px;
}
#paypal-container button span {
  color: #003187;
  font-weight: 900 !important;
  font-style: italic;
  font-size: 23px;
}

/*--------------------
DARK MODE
--------------------*/
:host-context(body.theme-dark) {
  background: #0a0c10 !important;
}
:host-context(body.theme-dark) .checkout-wrap {
  background: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .checkout-wrap header h1 {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .checkout-wrap .left-panel .header-wrap .se-check span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel {
  background: #111827 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box {
  border-color: rgba(148, 163, 184, 0.2) !important;
  background: #1e2535 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxheading {
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxheading h2,
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxheading h3,
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxheading h4 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxdetails h4 {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxdetails p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxdetails p span {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .sub-boxdetails p.Total {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .in-group input {
  background-color: #2d3748 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: #e2e8f0 !important;
  caret-color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .checkout-wrap .right-panel .subscription-box .in-group input::placeholder {
  color: #64748b !important;
}
:host-context(body.theme-dark) .panel {
  background: #1e2535 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .panel__header {
  background: #1d4072 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .panel__footer {
  background: #161e2e !important;
}
:host-context(body.theme-dark) .panel__footer button {
  background: #2563eb !important;
  color: #fff !important;
}
:host-context(body.theme-dark) .panel__content {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .hosted-field {
  color: #e2e8f0 !important;
  border-bottom-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .hosted-field--label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .hosted-field--label.label-float, :host-context(body.theme-dark) .hosted-field--label.filled, :host-context(body.theme-dark) .hosted-field--label.invalid {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .hosted-field--label.filled {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .hosted-field--label.invalid {
  color: #f87171 !important;
}
:host-context(body.theme-dark) .braintree-hosted-fields-focused {
  border-bottom-color: #3b82f6 !important;
}
:host-context(body.theme-dark) .braintree-hosted-fields-invalid {
  border-bottom-color: #ef4444 !important;
}
:host-context(body.theme-dark) svg {
  fill: #94a3b8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/checkout/checkout.component.scss"],"names":[],"mappings":"AAAA;;qBAAA;AASA;;qBAAA;AAIA;;;EAGE,mBAAA;AANF;;AASA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;AANF;;AASA;EACE,mBAAA;EACA,0CAAA;EACA,YAAA;AANF;;AASA;EACE,gBAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AANF;;AASA;;qBAAA;AAIA;EACE,gBAzCM;EA2CN,UAAA;EACA,0EAAA;EACA,gBAAA;AARF;;AAWA;EACE,mBApDK;EAqDL,WAlDM;AA0CR;;AAWA;;EAEE,gBAAA;AARF;;AAWA;EACE,mBA5DM;AAoDR;;AAWA;EACE,gBAAA;EACA,gBAAA;AARF;;AAWA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AARF;;AAWA;EACE,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,8BAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AARF;AASE;EACE,uBAAA;EACA,cAAA;EACA,8BAAA;AAPJ;AASE;EAEE,0BAAA;AARJ;AAUE;EAEE,cAAA;AATJ;;AAaA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;AAVF;;AAaA;EACE,UAAA;AAVF;;AAaA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,4CAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,qEAAA;AAVF;;AAaA;;qBAAA;AAIA;EACE,gCAAA;EACA,0BAAA;AAXF;;AAcA;EACE,gCAAA;EACA,0BAAA;AAXF;;AAcA;;uBAAA;AAIA;EACE;IACE,cAAA;EAZF;EAcA;IACE,YAAA;IACA,WAAA;IACA,eAAA;EAZF;EAcA;IACE,WAAA;EAZF;EAcA;IACE,WAAA;IACA,WAAA;IACA,qBAAA;EAZF;EAcA;IACE,WAAA;EAZF;AACF;AAeA,qBAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAbF;AAcE;EACE,UAAA;AAZJ;AAcI;EACE,WAAA;AAZN;AAaM;EACE,QAAA;AAXR;AAcI;EACE,aAAA;AAZN;AAaM;EACE,OAAA;AAXR;AAaM;EACE,aAAA;AAXR;AAYQ;EACE,QAAA;EACA,iBAAA;EACA,qCAAA;AAVV;AAeE;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;AAbJ;AAcI;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AAZN;AAaM;EACE,aAAA;EACA,mBAAA;AAXR;AAaQ;EACE,eAAA;EACA,uBAAA;EAAA,kBAAA;AAXV;AAcQ;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAZV;AAeM;EACE,aAAA;EACA,6BAAA;AAbR;AAeM;EACE,aAAA;AAbR;AAcQ;EACE,oBAAA;AAZV;AAeU;EACE,iBAAA;AAbZ;AAeU;EACE,kBAAA;AAbZ;AAgBQ;EACE,qBAAA;EACA,0BAAA;EACA,4BAAA;AAdV;AAkBI;EACE,aAAA;AAhBN;AAiBM;EACE,eAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,wBAAA;UAAA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;EAEA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAfR;AAiBM;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;EACA,kBAAA;AAfR;AAmBE;EACE,uBAAA;AAjBJ;AAkBI;EACE,qCAAA;EACA,iBAAA;EACA,0BAAA;AAhBN;;AAqBE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAlBJ;;AAqBA;EACE,kBAAA;AAlBF;;AAoBA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAjBF;AAoBE;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAlBJ;AAmBI;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAjBN;;AAsBA;EACE;IACE,WAAA;EAnBF;EAqBA;IACE,aAAA;IAEA,sBAAA;EApBF;EAqBE;IACE,WAAA;EAnBJ;EAoBI;IACE,mBAAA;EAlBN;EAsBE;IACE,kBAAA;IACA,WAAA;IACA,UAAA;IACA,QAAA;IACA,YAAA;IACA,QAAA;EApBJ;EAqBI;IACE,aAAA;IACA,gCAAA;EAnBN;EAoBM;IACE,gBAAA;EAlBR;EAmBQ;IACE,0BAAA;EAjBV;EAmBQ;IACE,0BAAA;EAjBV;EAmBQ;IACE,6BAAA;EAjBV;EAoBM;IACE,YAAA;EAlBR;EAsBE;IACE,QAAA;EApBJ;AACF;AAuBA;EACE,iBAAA;AArBF;AAsBE;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AApBJ;AAqBI;EACE,cAAA;EACA,2BAAA;EACA,kBAAA;EACF,eAAA;AAnBJ;;AAyBA;;qBAAA;AAGA;EACE,8BAAA;AAtBF;AAwBE;EACE,8BAAA;EACA,yBAAA;AAtBJ;AAwBI;EACE,yBAAA;AAtBN;AA0BM;EACE,yBAAA;AAxBR;AA4BI;EACE,8BAAA;AA1BN;AA4BM;EACE,iDAAA;EACA,8BAAA;EACA,yBAAA;AA1BR;AA4BQ;EACE,wDAAA;AA1BV;AA4BU;;;EAGE,yBAAA;AA1BZ;AA+BU;EACE,yBAAA;AA7BZ;AAgCU;EACE,yBAAA;AA9BZ;AAgCY;EACE,yBAAA;AA9Bd;AAkCU;EACE,yBAAA;AAhCZ;AAqCU;EACE,oCAAA;EACA,iDAAA;EACA,yBAAA;EACA,+BAAA;AAnCZ;AAqCY;EACE,yBAAA;AAnCd;AA2CE;EACE,8BAAA;EACA,yBAAA;AAzCJ;AA2CI;EACE,8BAAA;EACA,yBAAA;AAzCN;AA4CI;EACE,8BAAA;AA1CN;AA4CM;EACE,8BAAA;EACA,sBAAA;AA1CR;AA8CI;EACE,yBAAA;AA5CN;AAgDE;EACE,yBAAA;EACA,yDAAA;AA9CJ;AAiDE;EACE,yBAAA;AA/CJ;AAiDI;EACE,yBAAA;AA/CN;AAkDI;EACE,yBAAA;AAhDN;AAmDI;EACE,yBAAA;AAjDN;AAqDE;EACE,uCAAA;AAnDJ;AAsDE;EACE,uCAAA;AApDJ;AAuDE;EACE,wBAAA;AArDJ","sourcesContent":["/*--------------------\nSHARED VARIABLES\n--------------------*/\n$red: #e91e63;\n$blue: #3f51b5;\n$grey: #eae8e9;\n$grey2: #f3f3f3;\n$white: #fff;\n\n/*--------------------\nGENERAL\n--------------------*/\n\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nhtml {\n  box-sizing: border-box;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  background: #f2f2f2;\n  font-family: \"Roboto\", verdana, sans-serif;\n  height: 100%;\n}\n\nh1 {\n  font-size: 1.5em;\n  font-weight: 100;\n}\n\n#cardForm {\n  height: 100%;\n  display: flex;\n  justify-content: left;\n  align-items: center;\n}\n\n/*--------------------\nPANEL FORM\n--------------------*/\n\n.panel {\n  background: $white;\n  // background: transparent;\n  width: 80%;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 2px 0 rgba(0, 0, 0, 0.12);\n  box-shadow: none;\n}\n\n.panel__header {\n  background: $blue;\n  color: $white;\n}\n\n.panel__header,\n.panel__footer {\n  padding: 1em 2em;\n}\n\n.panel__footer {\n  background: $grey2;\n}\n\n.panel__content {\n  padding: 1em 2em;\n  overflow: hidden;\n}\n\n.textfield--float-label {\n  width: 50%;\n  float: left;\n  display: inline-block;\n  padding-right: 5px;\n}\n\n.hosted-field--label {\n  transform: translateY(0.4em);\n  font-size: 1.125em;\n  line-height: 32px;\n  transition: all 0.15s ease-out;\n  display: block;\n  width: 100%;\n  font-weight: 400;\n  overflow: hidden;\n  margin-bottom: 0.5em;\n  &.label-float {\n    text-overflow: ellipsis;\n    color: #2196f3;\n    transition: all 0.15s ease-out;\n  }\n  &.filled {\n    @extend .label-float;\n    color: rgba(0, 0, 0, 0.54);\n  }\n  &.invalid {\n    @extend .label-float;\n    color: #f44336;\n  }\n}\n\nspan.icon {\n  position: relative;\n  top: 0.2em;\n  margin-right: 0.2em;\n}\n\nsvg {\n  fill: #333;\n}\n\n.hosted-field {\n  height: 32px;\n  margin-bottom: 1em;\n  display: block;\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.87);\n  border: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.26);\n  outline: 0;\n  width: 100%;\n  font-size: 16px;\n  padding: 0;\n  box-shadow: none;\n  border-radius: 0;\n  position: relative;\n}\n\n.pay-button {\n  background: #e91e63;\n  color: #fff;\n  margin: 0 auto;\n  border: 0;\n  border-radius: 3px;\n  padding: 1em 3em;\n  font-size: 1em;\n  text-transform: uppercase;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.12), 0 2px 2px rgba(0, 0, 0, 0.2);\n}\n\n/*--------------------\nBT HOSTED FIELDS SPECIFIC \n--------------------*/\n\n.braintree-hosted-fields-focused {\n  border-bottom: 2px solid $blue;\n  transition: all 200ms ease;\n}\n\n.braintree-hosted-fields-invalid {\n  border-bottom: 2px solid $red;\n  transition: all 200ms ease;\n}\n\n/*---------------------\nMedia Queries\n----------------------*/\n\n@media (max-width: 600px) {\n  html {\n    overflow: auto;\n  }\n  #cardForm {\n    height: auto;\n    margin: 2em;\n    font-size: 13px;\n  }\n  .panel {\n    width: 100%;\n  }\n  .textfield--float-label {\n    width: 100%;\n    float: none;\n    display: inline-block;\n  }\n  .pay-button {\n    width: 100%;\n  }\n}\n\n/*design starts here*/\n.checkout-wrap {\n  display: flex;\n  align-items: flex-start;\n  padding: 2rem 3rem;\n  margin: 0px auto;\n  width: 100%;\n  .left-panel {\n    width: 70%;\n\n    .panel {\n      width: 100%;\n      span.icon{\n        top:0px;\n      }\n    }\n    .header-wrap {\n      display: flex;\n      h1 {\n        flex: 1;\n      }\n      .se-check {\n        display: flex;\n        span {\n          order: 2;\n          margin-left: 10px;\n          color: rgba(0, 0, 0, 0.54) !important;\n        }\n      }\n    }\n  }\n  .right-panel {\n    width: 27%;\n    background: #fff;\n    height: 100vh;\n    position: fixed;\n    right: 2rem;\n    top: 80px;\n    .subscription-box {\n      margin: 30px;\n      padding: 20px 0px 20px;\n      border: 1px solid #ddd;\n      border-radius: 10px;\n      h3 {\n        display: flex;\n        align-items: center;\n\n        &.back-link {\n          cursor: pointer;\n          width: fit-content;\n        }\n\n        mat-icon {\n          margin-right: 4px;\n          font-size: 22px;\n          width: 22px;\n          height: 22px;\n          line-height: 22px;\n        }\n      }\n      .sub-boxheading {\n        padding: 20px;\n        border-bottom: 1px solid #ddd;\n      }\n      .sub-boxdetails {\n        padding: 20px;\n        h4 {\n          margin: 0px 0px 20px;\n        }\n        p {\n          span {\n            margin-left: 10px;\n          }\n          i {\n            margin-right: 10px;\n          }\n        }\n        p.Total {\n          color: red !important;\n          font-size: 18px !important;\n          font-weight: bold !important;\n        }\n      }\n    }\n    .in-group {\n      display: flex;\n      input {\n        font-size: 18px;\n        height: 64px;\n        padding: 20px 22px 0;\n        background-color: #fff;\n        appearance: none;\n        border-radius: 9px;\n        border: 1px solid #c4c5ca;\n        box-sizing: border-box;\n        caret-color: #282d3d;\n        color: #282d3d;\n        display: inline-block;\n        -webkit-filter: none;\n        filter: none;\n        font-weight: 400;\n        height: 60px;\n        letter-spacing: normal;\n        line-height: normal;\n        outline: none;\n        padding: 0 30px;\n        resize: none;\n        vertical-align: middle;\n        width: 100%;\n      }\n      button {\n        width: 100px;\n        height: 80px;\n        border-radius: 9px;\n        height: 60px;\n        justify-content: center;\n        min-width: 88px;\n        width: 35%;\n        border:0px;\n        background: rgb(94, 161, 216);\n        color:#fff;\n        margin-left: -10px;\n      }\n    }\n  }\n  header {\n    background: transparent;\n    h1 {\n      color: rgba(0, 0, 0, 0.54) !important;\n      font-weight: bold;\n      font-size: 26px !important;\n    }\n  }\n}\n.panel__footer{\n  button{\n    display:block;\n    margin:0px auto;\n    background: #5ea1d8;\n    color: #fff;\n  }\n}\n.textfield--float-label{\n  position: relative;\n}\n.card-list{\n  display:flex;\n  position: absolute;\n  right:0px;\n  z-index: 10;\n  \n \n  ul{\n    list-style: none;\n    display: flex;\n    margin: 0px;\n    height: 32px;\n    align-items: end;\n    li{\n      width:20px;\n      margin:0px 3px;\n      cursor: pointer;\n    }\n  }\n}\n\n@media(max-width:992px){\n  #cardForm{\n    margin: 0px;\n  }\n  .checkout-wrap{\n    padding: 15px;\n   \n    flex-direction: column;\n    .left-panel{\n      width:100%;\n      .header-wrap .se-check{\n        align-items: center;\n      }\n\n    }\n    .right-panel{\n      position: relative;\n      width:100%;\n      right: 0px;\n      top:0px;\n      height: auto;\n      order:1;\n      .subscription-box{\n        padding: 15px;\n        margin:75px 0px 30px !important;\n        .sub-boxheading{\n          padding:5px 0px;\n          h2{\n            font-size: 24px !important;\n          }\n          h4{\n            font-size: 20px !important;\n          }\n          h3{\n            margin-bottom: 5px !important;\n          }\n        }\n        .sub-boxdetails{\n          padding:0px;\n        }\n      }\n    }\n    .left-panel{\n      order:2;\n    }\n  }\n}\n#paypal-container{\n  margin-left:30px;\n  button{\n    background: #ffc43a;\n    border-radius: 5px;\n    border: 0px;\n    padding: 5px 80px;\n    font-weight: 900;\n    color: #009cdf;\n    font-style: italic;\n    font-size: 23px;\n    span{\n      color:#003187;\n      font-weight:900 !important;\n      font-style: italic;\n    font-size: 23px;\n\n    }\n  }\n}\n\n/*--------------------\nDARK MODE\n--------------------*/\n:host-context(body.theme-dark) {\n  background: #0a0c10 !important;\n\n  .checkout-wrap {\n    background: #0a0c10 !important;\n    color: #e5e7eb !important;\n\n    header h1 {\n      color: #e2e8f0 !important;\n    }\n\n    .left-panel {\n      .header-wrap .se-check span {\n        color: #94a3b8 !important;\n      }\n    }\n\n    .right-panel {\n      background: #111827 !important;\n\n      .subscription-box {\n        border-color: rgba(148, 163, 184, 0.2) !important;\n        background: #1e2535 !important;\n        color: #e5e7eb !important;\n\n        .sub-boxheading {\n          border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n\n          h2,\n          h3,\n          h4 {\n            color: #f1f5f9 !important;\n          }\n        }\n\n        .sub-boxdetails {\n          h4 {\n            color: #f1f5f9 !important;\n          }\n\n          p {\n            color: #94a3b8 !important;\n\n            span {\n              color: #cbd5e1 !important;\n            }\n          }\n\n          p.Total {\n            color: #f87171 !important;\n          }\n        }\n\n        .in-group {\n          input {\n            background-color: #2d3748 !important;\n            border-color: rgba(148, 163, 184, 0.3) !important;\n            color: #e2e8f0 !important;\n            caret-color: #e2e8f0 !important;\n\n            &::placeholder {\n              color: #64748b !important;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .panel {\n    background: #1e2535 !important;\n    color: #e5e7eb !important;\n\n    &__header {\n      background: #1d4072 !important;\n      color: #e2e8f0 !important;\n    }\n\n    &__footer {\n      background: #161e2e !important;\n\n      button {\n        background: #2563eb !important;\n        color: #fff !important;\n      }\n    }\n\n    &__content {\n      color: #e5e7eb !important;\n    }\n  }\n\n  .hosted-field {\n    color: #e2e8f0 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .hosted-field--label {\n    color: #94a3b8 !important;\n\n    &.label-float {\n      color: #60a5fa !important;\n    }\n\n    &.filled {\n      color: #94a3b8 !important;\n    }\n\n    &.invalid {\n      color: #f87171 !important;\n    }\n  }\n\n  .braintree-hosted-fields-focused {\n    border-bottom-color: #3b82f6 !important;\n  }\n\n  .braintree-hosted-fields-invalid {\n    border-bottom-color: #ef4444 !important;\n  }\n\n  svg {\n    fill: #94a3b8 !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
